import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { DiscoverTempurLoveBlock as Value } from "@reactivated";

type Props = Immutable<{
    value: Value;
}>;

/**
 * React port of the pillows-specific ``DiscoverTempurLoveBlock``
 * (defined in ``server/cms/components/ads.py``). DOM mirrors the inline
 * markup that lived in ``cms/product_filter_grid_page.html`` (lines
 * ~168-182 of the legacy template before the F5 cutover). Unlike
 * ``InsideInnovationBlock``, the ``title`` and ``copy`` CharBlocks are
 * NOT rendered through ``|safe`` in Django — they're plain text — so we
 * render them as plain children.
 */
export const DiscoverTempurLoveBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    const linkUrl = v.page_link?.url ?? "";
    const imageUrl = v.image?.url ?? "";
    return (
        <div className="discover-tempur-love l-full-width">
            <div className="l-full-width">
                <div className="discover-tempur-love__copy">
                    <div className="discover-tempur-love__title">{v.title}</div>
                    <div className="discover-tempur-love__sub-title">
                        {v.copy}
                    </div>
                </div>
                {/* Link wraps an image with empty alt; pass the heading
                    text (or a translated fallback) as the accessible name.
                    See #13290. */}
                <a
                    href={linkUrl}
                    aria-label={v.title || t`Discover Tempur Love`}
                >
                    <div className="discover-tempur-love__image-container">
                        <img
                            src={imageUrl}
                            alt=""
                            className="discover-tempur-love__image al-product-grid__discover-tempur-love responsive-img"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                </a>
            </div>
        </div>
    );
};
